import globalAxios, { type AxiosInstance, type AxiosPromise, type AxiosRequestConfig } from 'axios';
import type { Configuration } from './configuration';
import { BaseAPI } from './base';
import type { ResultVo } from './api';

/**
 * 与 BlacklistController 保持同名的生成式客户端扩展。
 * 下次通过 Swagger 重新生成 src/api 后，应以生成结果覆盖本文件。
 */
export interface BlacklistAdminVo {
  id?: number;
  phone: number;
  remark?: string;
  createTime?: string;
  updateTime?: string;
}

export interface BlacklistPageRequest {
  conditions: Partial<BlacklistAdminVo>;
  pageQuery: {
    page: number;
    pageSize: number;
  };
}

export class BlacklistApi extends BaseAPI {

  constructor(configuration?: Configuration, basePath?: string, axios: AxiosInstance = globalAxios) {
    super(configuration, basePath, axios);
  }

  public listBlacklistBlacklist(conditions: Partial<BlacklistAdminVo>, options?: AxiosRequestConfig): AxiosPromise<ResultVo> {
    return this.axios.request<ResultVo>({
      ...options,
      data: conditions,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      method: 'POST',
      url: `${this.basePath}/blacklist/listBlacklist`,
    });
  }

  public pageBlacklistBlacklist(request: BlacklistPageRequest, options?: AxiosRequestConfig): AxiosPromise<ResultVo> {
    return this.axios.request<ResultVo>({
      ...options,
      data: request,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      method: 'POST',
      url: `${this.basePath}/blacklist/pageBlacklist`,
    });
  }

  public addBlacklistBlacklist(blacklistAdminVo: BlacklistAdminVo, options?: AxiosRequestConfig): AxiosPromise<ResultVo> {
    return this.axios.request<ResultVo>({
      ...options,
      data: blacklistAdminVo,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      method: 'POST',
      url: `${this.basePath}/blacklist/addBlacklist`,
    });
  }

  public updateBlacklistBlacklist(blacklistAdminVo: BlacklistAdminVo, options?: AxiosRequestConfig): AxiosPromise<ResultVo> {
    return this.axios.request<ResultVo>({
      ...options,
      data: blacklistAdminVo,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
      method: 'PUT',
      url: `${this.basePath}/blacklist/updateBlacklist`,
    });
  }

  public deleteBlacklistBlacklist(blacklistId: number, options?: AxiosRequestConfig): AxiosPromise<ResultVo> {
    return this.axios.request<ResultVo>({
      ...options,
      headers: {
        ...options?.headers,
      },
      method: 'DELETE',
      params: {
        ...options?.params,
        blacklistId,
      },
      url: `${this.basePath}/blacklist/deleteBlacklist`,
    });
  }

}
